import { defineEvents, SHARED_EVENTS } from '@3plearning/mx-teacher-analytics';

const CERTIFICATE_REPORT = 'certificate_report';

export const appEvents = defineEvents({
    ...SHARED_EVENTS,
    'export.click': {
        group: CERTIFICATE_REPORT,
        props: {} as {
            certificate_tab: 'new' | 'past'
            classroom_id: string
            group_id: string
            date_range_id: string
            start_date: string
            end_date: string
            row_count: number
            total_certificates: number
            is_all_classes: boolean
            is_all_groups: boolean
        }
    }
});

export type AppEvents = typeof appEvents;
